function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from "react";
import { Menu, Button, Space, Image, Drawer } from "antd";
import { ShieldLockFill, Speedometer, CupFill } from "react-bootstrap-icons";
import { Container, Row, Col } from "react-bootstrap";
import Card from "../Card";
import Start from "../forms/Start";
import { useNavigate } from "react-router-dom";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SubMenu = Menu.SubMenu;

var DefaultNav = function DefaultNav(_ref) {
  var handleConnectButton = _ref.handleConnectButton;

  var _useState = useState('home'),
      _useState2 = _slicedToArray(_useState, 2),
      current = _useState2[0],
      setCurrent = _useState2[1];

  var navigate = useNavigate();

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      drawerVisible = _useState4[0],
      setDrawerVisible = _useState4[1];

  var menuItems = [{
    label: /*#__PURE__*/_jsx("b", {
      children: "Accueil"
    }),
    key: 'home'
  }, {
    label: /*#__PURE__*/_jsx("b", {
      children: "Nous contacter"
    }),
    key: "contact"
  }];
  return /*#__PURE__*/_jsxs("div", {
    className: "nav-wrapper",
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 2,
          md: 3,
          sm: 3,
          xs: 4,
          children: /*#__PURE__*/_jsx(Image, {
            src: "/drawables/cl.png",
            preview: false,
            width: "170px"
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 6,
          sm: 5,
          xs: 4,
          children: /*#__PURE__*/_jsx(Menu, {
            onClick: function onClick(e) {
              if (e.key == 'contact') {
                navigate('contact');
              }

              if (e.key == 'home') {
                navigate('/');
              }
            },
            mode: "horizontal",
            items: menuItems
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 2,
          md: 3,
          sm: 4,
          xs: 4,
          children: /*#__PURE__*/_jsx(Button, {
            style: {
              background: "#FFF9F1"
            },
            size: "large",
            type: "default",
            onClick: function onClick() {
              setDrawerVisible(true);
            },
            children: /*#__PURE__*/_jsx("b", {
              style: {
                color: "#D19040"
              },
              children: "Commencer"
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "Commencer"
      }),
      width: "100%",
      onClose: function onClose() {
        setDrawerVisible(false);
      },
      destroyOnClose: false,
      open: drawerVisible,
      children: /*#__PURE__*/_jsx(Start, {})
    })]
  });
};

export default DefaultNav;